import { Input, Select } from "../../../components/ui";
import type { EmpresaConfiguracion, EmpresaConfiguracionUpdate } from "../api";
import { SaveBar, nullIfEmpty, useConfigForm } from "./_shared";

interface Form {
  banco_nombre: string;
  tipo_cuenta: string;
  banco_cuenta: string;
  nombre_titular_cuenta: string;
  rut_titular_cuenta: string;
}

const extractor = (cfg: EmpresaConfiguracion): Form => ({
  banco_nombre: cfg.banco_nombre ?? "",
  tipo_cuenta: cfg.tipo_cuenta ?? "",
  banco_cuenta: cfg.banco_cuenta ?? "",
  nombre_titular_cuenta: cfg.nombre_titular_cuenta ?? "",
  rut_titular_cuenta: cfg.rut_titular_cuenta ?? "",
});

const differ = (
  f: Form,
  cfg: EmpresaConfiguracion,
): EmpresaConfiguracionUpdate => {
  const out: EmpresaConfiguracionUpdate = {};
  if (nullIfEmpty(f.banco_nombre) !== cfg.banco_nombre)
    out.banco_nombre = nullIfEmpty(f.banco_nombre);
  if (nullIfEmpty(f.tipo_cuenta) !== cfg.tipo_cuenta)
    out.tipo_cuenta = nullIfEmpty(f.tipo_cuenta);
  if (nullIfEmpty(f.banco_cuenta) !== cfg.banco_cuenta)
    out.banco_cuenta = nullIfEmpty(f.banco_cuenta);
  if (nullIfEmpty(f.nombre_titular_cuenta) !== cfg.nombre_titular_cuenta)
    out.nombre_titular_cuenta = nullIfEmpty(f.nombre_titular_cuenta);
  if (nullIfEmpty(f.rut_titular_cuenta) !== cfg.rut_titular_cuenta)
    out.rut_titular_cuenta = nullIfEmpty(f.rut_titular_cuenta);
  return out;
};

const TIPOS_CUENTA = [
  "Cuenta Corriente",
  "Cuenta Vista",
  "Cuenta de Ahorro",
  "Chequera Electrónica",
];

export function BancoTab({
  cfg,
}: {
  cfg: EmpresaConfiguracion;
}): JSX.Element {
  const { form, setForm, haycambios, pending, reset, save } = useConfigForm(
    cfg,
    extractor,
    differ,
  );

  return (
    <div className="space-y-4 max-w-2xl">
      <p className="text-sm text-neutral-600">
        Cuenta bancaria para que los socios depositen el pago de sus boletas.
        Estos datos se imprimen en el pie de la boleta.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Input
          label="Banco"
          type="text"
          value={form.banco_nombre}
          onChange={(e) => setForm({ ...form, banco_nombre: e.target.value })}
          placeholder="Banco Estado, BancoChile, etc."
        />
        <Select
          label="Tipo de cuenta"
          value={form.tipo_cuenta}
          onChange={(e) => setForm({ ...form, tipo_cuenta: e.target.value })}
        >
          <option value="">— Seleccione —</option>
          {TIPOS_CUENTA.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </Select>
        <Input
          label="N° de cuenta"
          containerClassName="sm:col-span-2"
          type="text"
          value={form.banco_cuenta}
          onChange={(e) => setForm({ ...form, banco_cuenta: e.target.value })}
        />
        <Input
          label="Titular"
          type="text"
          value={form.nombre_titular_cuenta}
          onChange={(e) =>
            setForm({ ...form, nombre_titular_cuenta: e.target.value })
          }
        />
        <Input
          label="RUT titular"
          type="text"
          value={form.rut_titular_cuenta}
          onChange={(e) =>
            setForm({ ...form, rut_titular_cuenta: e.target.value })
          }
          placeholder="76.555.000-1"
        />
      </div>

      <SaveBar
        haycambios={haycambios}
        pending={pending}
        reset={reset}
        save={save}
      />
    </div>
  );
}
